<template>
    <div class="QHcheckboxGroup" :class="{ disabled: disabled }">
        <CheckboxGroup v-model="values" @on-change="getValue">
            <slot></slot>
        </CheckboxGroup>
    </div>
</template>

<script>

export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            values: [],
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        value: {
            type: [Array, String],
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:watch
    // +----------------------------------------------------------------------
    watch: {
        value() {
            this.setValue();
        }
    },
    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        getValue(data) {
            this.$emit('input', data.join(','));
        },
        setValue() {
            if (!this.$isblank(this.value)) {
                var value=this.$FMT.toString(this.value);
                this.values = value.split(',');
            }else{
                this.values=[];
            };
        },
    }
}
</script>
<style scoped>
.QHcheckboxGroup {
    position: relative;
}

.QHcheckboxGroup.disabled::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
}
</style>